import React from 'react';
import TopPanel from "./toppanel.js";
import CheckListView from "./checklists/checklistview.js";
import Modal from './modal.js';

module.exports = React.createClass({
    getInitialState() {
        return {
            name: this.props.name,
            content: this.props.content,
            exit: false,
            success: false,
            files: this.props.files.map(function(f){return $.extend(true, {}, f)})
        };
    },
    onNameChanged: function(o) {
        this.setState({name: o.target.value});
    },
    onContentChanged: function(o) {
        this.setState({content: o.target.value});
    },
    close: function() {
        this.state.files = this.props.files;
        HC_CloseModal();
    },
    save: function() {
        if (this.state.name.trim().length === 0)
            return;
        this.state.success = true;
        var newFiles = this.state.files.filter(function(f){return f.state === 'done'}).map(function(f){return f.path});
        var deletedFiles = this.state.files.filter(function(f){return f.state === 'deleted'}).map(function(f){return f.path});
        this.props.save({id: this.props.id, name: this.state.name, content: this.state.content, new_files: newFiles, deleted_files: deletedFiles});
        this.setState({exit: true});
    },
    componentWillUnmount: function() {
        if (!this.state.success)
            this.props.cancel();
    },
    componentDidMount: function() {
        $('#hc-doc-edit').on('focusin', function(ev) {$('#hc-doc-edit').parent().css({'box-shadow':'inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)', 'border-color': '#66afe9', outline: 0})})
        $('#hc-doc-edit').on('focusout', function(ev) {$('#hc-doc-edit').parent().css({'box-shadow':'', 'border-color': '', outline: ''})})
    },
    sendFile: function(e) {
        var input = e.target;
        if (input.files.length > 0) {
            var filePath = HC_Guid();
            if (input.files[0].size > this.props.maxSize) {
                this.state.files.push({big: true, name: HC_LANG.DOC_ERROR_BIG_FILE, path: filePath, state: 'error', fileInfo: input.files[0]});
                this.setState({files: this.state.files});
                return;
            }
            this.state.files.push({name: input.files[0].name, path: filePath, state: 'upload', fileInfo: input.files[0]});
            this.setState({files: this.state.files});
            this.props.sendFileRequest(filePath, input.files[0], this);
            input.value = '';
        }
    },
    deleteFile: function(ev) {
        var path = ev.target.getAttribute('data-key');
        var item = this.state.files.filter(function(f){return f.path==path;});
        if (item.length === 1) {
            var file = item[0];
            if (file.state) {
                this.state.files.splice(file = this.state.files.indexOf(file), 1);
                if (!file.big)
                    HC_SendRequest('delete_file', {path: path}, null, function(){});
            } else {
                file.state = 'deleted';
            }
            this.setState({files: this.state.files});
        }
    },
    downloadFile: function(path, name) {
        HC_DownloadFile(path, name);
    },
    reuploadFile: function(path) {
        var filteredFiles = this.state.files.filter(function(f){return f.path == path});
        if (filteredFiles.length === 1 && !filteredFiles[0].big) {
            var file = filteredFiles[0];
            var newPath = HC_Guid();
            file.path = newPath;
            file.state = 'upload';
            this.forceUpdate();
            this.props.sendFileRequest(newPath, file.fileInfo, this);
        }
    },
    render: function () {
        var buttonsStyle = {paddingTop:'2%'};
        if (this.state.exit)
            buttonsStyle.display = 'none';
        var caption = this.props.id == -1 ? HC_LANG.DOC_CREATE_DOC : HC_LANG.DOC_EDIT_DOC;

        var classBtn = "hc-button";
        var opts = {};
        var badFiles = this.state.files.filter(function(f){return f.state != null && f.state !== 'done' && f.state !== 'deleted'}).length > 0;
        if (this.state.name.trim().length === 0 || badFiles) {
            classBtn += ' hc-button-off';
            opts['disabled'] = 'disabled';
        }

        var files;
        var hasFiles = this.state.files && this.state.files.filter(function(f){return f.state !== 'deleted'}).length > 0;
        if (hasFiles) {
            var i = 0;
            var fileItems = this.state.files.filter(function(f){return f.state!=='deleted'}).map(function(f) {
                var faIcon, iconDiv, progressDiv, textColor = '#8a8d91', fileClick, cursor = 'default';
                if (!f.state)
                    faIcon = 'hc-green fa-file-text-o';
                else if (f.state == 'done')
                    faIcon = 'hc-green fa-check';
                else if (f.state == 'error')
                    faIcon = 'hc-red fa-exclamation-circle';
                else if (f.state == 'upload') {
                    textColor = 'rgba(138, 141, 145, 0.5)';
                    progressDiv = (<div>
                        <svg style={{height:"80", width:"120"}}>
                            <g style={{fill:"none", stroke:"#30ae97", strokeWidth:"3"}}>
                                <path id={'progress-arc-' + f.path}/>
                            </g>
                                    <span id={'progress-count-' + f.path} className="hc-f4"
                                          style={{position:'absolute', top:'35px', left:0, right:0, textAlign: "center", color:textColor}}>0%</span>
                        </svg>
                    </div>);
                }

                if (faIcon) {
                    iconDiv = (
                        <div className="hc-f4" style={{position:'absolute', top:'30px', left:0, right:0, textAlign: "center"}}>
                            <i className={"fa " + faIcon} style={{fontSize:'48px'}}/>
                        </div>
                    );
                }

                if (!f.state || f.state === 'error') {
                    cursor = 'pointer';
                    if (!f.state)
                        fileClick = function(ev){this.downloadFile(f.path, f.name)}.bind(this);
                    if (f.state === 'error')
                        fileClick = function(ev){this.reuploadFile(f.path)}.bind(this);
                }

                return (
                    <div key={++i} style={{position:'relative', display:'inline-block', width:'130px', height:'150px', marginTop:'7px', marginRight:'12px', overflow:"hidden"}}>
                        <div className="hc-ba" data-key={f.path} onClick={fileClick} style={{position:'absolute', width:'120px', height:'140px', marginTop:'10px', marginRight:'10px', overflow:"hidden", cursor: cursor}}>
                            {iconDiv}
                            {progressDiv}
                            <div className="hc-f4" style={{position:'absolute', top:'90px', left:0, right:0, paddingLeft:'2px', paddingRight:'2px', textAlign: "center", color:textColor, wordBreak:'break-word'}}>{f.name}</div>
                        </div>
                        <div className="fa fa-times hc-delete-file" data-key={f.path} onClick={this.deleteFile} style={{fontSize:'24px', padding:'5px', paddingLeft:'7px', paddingBottom:'7px', position:'absolute', top:'-6px', right:'-4px', backgroundColor:'white', color:'#bfc7cd', cursor:'pointer'}}/>
                    </div>
                )
            }.bind(this));
            files = (<div style={{height:'165px', marginLeft:'8px', overflowY: "auto", WebkitOverflowScrolling:'touch'}}>
                {fileItems}
            </div>)
        }

        return (
            <Modal data-style={{width: '63rem'}}>
                <div className="hc-close-btn hc-f2" onClick={this.close}>
                    <i style={{float:'right', margin:'1rem', marginBottom:'50%'}} className="fa fa-times"></i>
                </div>
                <div style={{margin:'3rem', height:'100%'}}>
                    <div className="hc-f2" style={{textAlign:'center', marginBottom:'2%'}}>{caption}</div>
                    <input className="form-control hc-f3" style={{marginBottom:'2%'}}
                           placeholder={HC_LANG.CHL_NAME} value={this.state.name}
                           onChange={this.onNameChanged}/>
                    <div className="form-control" style={{width:'100%', height:(hasFiles ? '455px': '315px')}}>
                                <textarea id="hc-doc-edit" className="hc-doc-edit form-control custom-control hc-f3"
                                          style={{width:'100%', resize:'none', height:(hasFiles ? '270px': '300px'), border:'none', boxShadow:'none', padding: 0}}
                                          placeholder={HC_LANG.DOC_CONTENT} value={this.state.content}
                                          onChange={this.onContentChanged}></textarea>
                        {files}
                    </div>
                    <div style={buttonsStyle}>
                        <button className={classBtn} style={{fontSize:"1.125rem"}} {...opts}
                                onClick={this.save}>{HC_LANG.DUE_SAVE}</button>
                        <button className="hc-button-cancel" style={{fontSize:"1.125rem", marginLeft:"2%"}}
                                onClick={this.close}>{HC_LANG.DUE_CANCEL}</button>
                        <div className="hc-file-upload hc-button" style={{float:'right'}}>
                            <span style={{fontSize:"1.125rem"}}>{HC_LANG.DOC_ATTACH_FILE}</span>
                            <input type="file" className="hc-upload" accept='*' onChange={this.sendFile}/>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
});


// WEBPACK FOOTER //
// ./EditDocument.js